import React, { useEffect, useState } from "react";
import { EmptyState } from "../../shared/components/EmptyState";
import { LoadingAnimation } from "../../shared/components/Loading";
import { Table } from "react-bootstrap";
import { t } from "i18next";
import { Link, useNavigate } from "react-router-dom";
import { getCorrectLanguage } from "../../shared/functions/Functions";
import { useSelector } from "react-redux";
import { IAllStates } from "../../store/rootReducer";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { ClientCustomService } from "./service";
import { Pagination } from "../../shared/paginations/Paginations";
import _debounce from "lodash/debounce";
export const ClientCustom = () => {
  const [products, setPoducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState<
    { productId: string; variation: number }[]
  >([]);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { accessRights } = useSelector((state: IAllStates) => state.auth);
  const navigate = useNavigate();
  const [productsLaguage, setPoductsLaguage] = useState([]);
  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  const [searchSku, setSearchSku] = useState("");

  useEffect(() => {
    ClientCustomService.getAllSemgProducts(pagination)
      .then((response) => {
        const { data } = response;
        if (pagination?.page > 1 && pagination?.page > response?.totalPages) {
          setPage(response?.totalPages);
          setPagination({ ...pagination, page: response?.totalPages });
        }
        setPoducts(data as any);
        setPoductsLaguage(getLanguages(data) as any);
        setTotalPages(response?.totalPages);
      })
      .catch((error) => ErrorToast(error));
  }, [pagination]);
  useEffect(() => {
    const savedSku = localStorage.getItem("searchSku") ?? "";
    if (savedSku) {
      const timer = setTimeout(() => {
        setSearchSku(savedSku);
        setPagination((prev) => ({ ...prev, sku: savedSku }));
      }, 250);

      return () => clearTimeout(timer);
    }
  }, []);
  const getLanguages = (data: any[]) => {
    const languages = new Set();
    data.forEach((item) => {
      Object.keys(item.masterData?.current?.name).forEach((lang) => {
        languages.add(lang);
      });
    });
    return Array.from(languages);
  };
  const handleCheckboxChange = (
    productId: any,
    variantId: any,
    isChecked: boolean
  ) => {
    const entry = {
      productId: productId,
      variation: variantId ?? 0,
    };

    if (isChecked) {
      setSelectedProducts((prev) => [...prev, entry]);
    } else {
      setSelectedProducts((prev) =>
        prev.filter(
          (item) => item.productId !== productId || item.variation !== variantId
        )
      );
    }
  };
  const handleDownload = (file: any, name: string) => {
    const xhr = new XMLHttpRequest();
    const fileName = name;
    xhr.open("GET", file, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: "application/*" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? "";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 0);
      }
    };
    xhr.send();
  };
  const submitHandler = () => {
    ClientCustomService.export({
      products: selectedProducts,
    })
      .then((res) => {
        setSelectedProducts([]);
        const filePath = res?.path;
        const fileName = filePath?.split("/").pop();
        const fileExtension = fileName.split(".").pop();
        handleDownload(filePath, "semg" + "." + fileExtension);
        SuccessToast(t(`toasts.successfully_exported`));
      })
      .catch((err) => console.log(err));
  };
  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  const toggleRow = (productId: number) => {
    setExpandedRows((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };
  const debouncedFilter = _debounce((name: string, value: string) => {
    setPagination((prev) => ({ ...prev, [name]: value }));
    localStorage.setItem("searchSku", value ?? "");
  }, 200);

  const changeFilterHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setSearchSku(value);
    debouncedFilter(name, value);
  };

  return (
    <>
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-info mb-3 d-flex align-items-center"
            onClick={() => navigate("/app/clients")}
          >
            <i className="ri-arrow-left-line"></i>
            <span className="ms-1">{t("global.back")}</span>
          </button>
          <h4>Semg</h4>
        </div>
      </div>
      <div className="card">
        <div className="card-header pb-0">
          <div className="d-flex justify-content-between">
            <h4 className="card-title mg-b-0">List of products</h4>
            <div
              className="d-flex align-items-center justify-content-center mb-2"
              style={{ width: "50%" }}
            >
              <input
                className="form-control w-100"
                name="sku"
                value={searchSku}
                onChange={changeFilterHandler}
                placeholder={`${t("clients.searchSku")}...`}
                type="text"
              />
              <button
                className="btn btn-secondary d-flex align-items-center ms-3"
                type="button"
                onClick={submitHandler}
                aria-expanded="false"
                disabled={selectedProducts?.length < 1}
              >
                {`${t("global.export")}`}
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          {products == undefined ? (
            <LoadingAnimation />
          ) : products.length === 0 ? (
            <EmptyState />
          ) : (
            <div className="table-responsive">
              <Table className="align-middle table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" rowSpan={2}></th>
                    <th scope="col" rowSpan={2}>
                      {t("global.id")}
                    </th>

                    <th colSpan={productsLaguage?.length} rowSpan={1}>
                      {t("global.name")}
                    </th>
                  </tr>
                  <tr>
                    {productsLaguage?.map((item: string) => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {products?.map((product: any, index: number) => {
                    const isExpanded = expandedRows.includes(product.id);
                    const hasVariants =
                      product?.masterData?.variants?.length > 0;
                    return (
                      <React.Fragment key={`${product?.id}-${index}`}>
                        <tr>
                          <td>
                            {hasVariants && (
                              <button
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center"
                                onClick={() => toggleRow(product.id)}
                              >
                                {isExpanded ? (
                                  <i
                                    className="ri-arrow-drop-up-line"
                                    style={{
                                      fontSize: "1.3rem",
                                      lineHeight: "normal",
                                    }}
                                  ></i>
                                ) : (
                                  <i
                                    className="ri-arrow-drop-down-line"
                                    style={{
                                      fontSize: "1.3rem",
                                      lineHeight: "normal",
                                    }}
                                  ></i>
                                )}
                                <span>
                                  {product?.masterData?.variants?.length ?? 0}
                                </span>
                              </button>
                            )}
                          </td>
                          <td>
                            {/* <Link
                              to={`/app/clients/semg/${product?.id}/${product?.variant?.id}`}
                              className="fw-medium"
                            > */}
                            <span className="fw-600">#{product?.id}</span>
                            {/* </Link> */}
                          </td>

                          {productsLaguage?.map((lang: string) => (
                            <td key={lang}>
                              {product?.masterData?.current?.name?.[lang] ??
                                "-"}
                            </td>
                          ))}
                        </tr>

                        {isExpanded && hasVariants && (
                          <tr>
                            <td colSpan={productsLaguage.length + 3}>
                              {product.masterData.variants.map(
                                (variant: any) => {
                                  const isSelected = selectedProducts.some(
                                    (item) =>
                                      item.productId === product.id &&
                                      item.variation === (variant?.id ?? 0)
                                  );

                                  return (
                                    <div
                                      key={variant?.id}
                                      className="d-flex justify-content-between align-items-center my-1"
                                    >
                                      <div>
                                        <input
                                          className="ms-5"
                                          type="checkbox"
                                          checked={isSelected}
                                          onChange={(e) =>
                                            handleCheckboxChange(
                                              product.id,
                                              variant?.id,
                                              e.target.checked
                                            )
                                          }
                                        />
                                      </div>
                                      <div>
                                        <span className="fw-bold">
                                          <Link
                                            to={`/app/clients/semg/${product?.id}/${variant?.id}`}
                                            className="fw-medium"
                                          >
                                            {variant?.sku}
                                          </Link>
                                        </span>
                                      </div>
                                      <div>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={() =>
                                            navigate(
                                              `/app/clients/semg/${product?.id}/${variant?.id}`
                                            )
                                          }
                                        >
                                          <i className="ri-eye-fill me-1" />
                                          {t("global.view")}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
          <div className="d-flex justify-content-end ">
            {totalPages <= 1 ? (
              ""
            ) : (
              <Pagination
                page={page}
                totalPages={totalPages}
                handlePagination={handlePages}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
